export default __webpack_public_path__ + "8176f7959d6883afe6fae3a4e610523f.svg";